import {useTranslation} from "react-i18next";
import {Box, Button, Grid, Typography} from "@mui/material";
import React from "react";

export type NotFinishedTestActionsProps = { continueTest: () => void, restartTest: () => void };

export function NotFinishedTestActions({continueTest, restartTest}: NotFinishedTestActionsProps) {
    const {t} = useTranslation()

    return <Box my={7}>
        <Grid container>
            <Grid item xs={12}>
                <Box mb={3}>
                    <Typography variant="h5" align="center">{t('test.notFinishedTestText')}</Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Grid container justifyContent="center" spacing={2}>
                    <Grid item>
                        <Button
                            color="primary"
                            onClick={continueTest}
                            size="large"
                        >
                            {t('test.continueTestButton')}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button color="secondary" onClick={restartTest} size="large">
                            {t('test.repeatTestButton')}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </Box>;
}
